<h1>Emails</h1>

<div class="card">
  <div class="card-header">
    Emails
  </div>
  <div class="card-block">
    <div class="loading-cont" *ngIf="loading"><div class="loading-spinner"></div></div>
    <p class="no-items-found" *ngIf="!loading && 0 === items.length">No items found.</p>

    <div class="row" *ngIf="!loading && 0 < items.length" style='padding: 12px'>
      <div class='col-md-3 email-list'>
        <h2 style='text-align: center;'>Subjects</h2>
        <button (click)='selectItem(i)' *ngFor='let email of items; let i = index' class='btn btn-default btn-block' style='white-space: normal'>
          {{ email.subject }}
        </button>
      </div>
      <div class='col-md-9 selected-email'>
        <h2 *ngIf='!selectedItem'>No item is selected</h2>
        <ng-container *ngIf='selectedItem'>
          <h2>Subject</h2>
          <p>{{ selectedItem.subject }}</p>
          <hr>
          <h2>Body</h2>
          <div [innerHTML]="selectedItem.body"></div>
          <hr>
          <h2>Details</h2>
          <p>{{ selectedItem.details }}</p>
        </ng-container>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/emails/emails-listing/emails-listing.component.html